import { Navigate, useParams } from 'react-router-dom';

/** Redirige rutas legacy de consentimiento externo (Docty) al flujo interno Redplika */
const ConsentimientoPublico = () => {
  const { appointmentId } = useParams();
  if (appointmentId) {
    return <Navigate to={`/consentimiento/${appointmentId}`} replace />;
  }
  return <Navigate to="/consentimiento" replace />;
};

export default ConsentimientoPublico;
